export default __webpack_public_path__ + "static/media/share.df828a36.svg";